import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const URL_API = process.env.REACT_APP_API_URL;
// const URL_API = "http://localhost:8000/";

export const fetchSendMail = createAsyncThunk(
  "contact-us/send-mail",
  async (data, thunkAPI) => {
    console.log("data: ", data);
    console.log("URL_API: ", URL_API);
    try {
      const response = await axios.post(`${URL_API}mail/send`, data);
      console.log("response: ", response);
      return response.data;
    } catch (error) {
      console.log("error");

      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const contactSlice = createSlice({
  name: "contact-us",
  initialState: {
    isSent: false,
    message: null,
    errors: {},
    loading: false,
  },
  reducers: {
    resetErrors: (state) => {
      state.errors = {};
    },
  },
  extraReducers: {
    [fetchSendMail.pending]: (state) => {
      state.loading = true;
    },
    [fetchSendMail.fulfilled]: (state, action) => {
      state.loading = false;
      state.isSent = true;
      state.message = action.payload;
    },
    [fetchSendMail.rejected]: (state, action) => {
      state.loading = false;
      state.errors = action.payload;
    },
  },
});

export const { resetErrors } = contactSlice.actions;

export default contactSlice.reducer;
